import React from "react";
import { useCurrentDashboard } from "../useCurrentDashboard";
import { SignalsDashboardType } from "../SignalsModels";
import { Grid, keyframes, styled } from "@mui/material";
import { observer } from "mobx-react";

// Component to display the dashboard logo if it is a custom dashboard with a logo
export const DashboardLogo = observer(() => {
    const currentDashboard = useCurrentDashboard();

    return currentDashboard?.dashboardType === SignalsDashboardType.Custom &&
        currentDashboard.logoName ? (
        <Grid
            item
            display={"flex"}
            alignItems={"center"}
            justifyContent={"center"}
            height={80}
            width={80}
            mr={1.5}
            sx={{
                "& img": { display: "none" },
                "& img.loaded": { display: "block" },
            }}
        >
            {currentDashboard.isLogoLoading && <SkeletonDiv />}
            {!currentDashboard.isLogoLoading &&
                currentDashboard.isLogoSourceMissing && (
                    <MissingSourceDiv>Source not found</MissingSourceDiv>
                )}
            {currentDashboard.logo && (
                <img
                    src={currentDashboard.logo.blobSasUrl}
                    alt={currentDashboard.logoName}
                    style={{
                        display: "block",
                        height: "80px",
                        width: "80px",
                        borderRadius: "8px",
                        objectFit: "cover",
                    }}
                />
            )}
        </Grid>
    ) : null;
});

// Skeleton loading animation
const loading = keyframes`
  0% {
    left: -100%;
  }
  100% {
    left: 100%;
  }
`;

// Styled div for skeleton loading
const SkeletonDiv = styled("div")`
    width: 80px;
    height: 80px;

    background-color: #e5e7eb;
    border-radius: 8px;
    position: relative;
    overflow: hidden;

    &::before {
        content: "";
        position: absolute;
        top: 0;
        left: -100%;
        width: 100%;
        height: 100%;
        background: linear-gradient(
            45deg,
            rgba(255, 255, 255, 0.2) 25%,
            rgba(255, 255, 255, 0.5) 50%,
            rgba(255, 255, 255, 0.2) 75%
        );
        animation: ${loading} 1.5s infinite;
    }
`;

const MissingSourceDiv = styled("div")`
    width: 80px;
    height: 80px;
    border-radius: 8px;
    background: #f4f4f5;
    color: #71717a;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    font-size: 11px;
    font-weight: 600;
    line-height: 14px;
    padding: 8px;
`;
